<template>
  <a-drawer
    :maskClosable="false"
    width="45%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-descriptions :column="4" title="经销商信息" class="full-width-descriptions">
      <a-descriptions-item label="经销商名称"  span="3">
        {{ formDate.tenantAgentId == formDate.tenantId ? formDate.tenantName : formDate.tenantAgentName }}
         <a-button type="primary" style="margin-left: 30px" @click="$refs.CreateMoney.init(formDate.tenantAgentId == formDate.tenantId?formDate.tenantId:formDate.tenantAgentId)"> 调整资金 </a-button>
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions :column="4" title="分销商信息" class="full-width-descriptions"   v-if="form.tenantAgentId !== form.tenantId && form.tenantFirmId !== form.tenantId">
      <a-descriptions-item label="分销商名称" span="3">
        {{ formDate.tenantName }}
         <a-button type="primary" style="margin-left: 30px" @click="$refs.CreateMoney.init(formDate.tenantId)"> 调整资金 </a-button>
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions :column="4" title="验收员信息" class="full-width-descriptions">
      <a-descriptions-item label="验收员名称"> {{ formDate.pressureTestName }} </a-descriptions-item>
      <a-descriptions-item label="验收员电话" span="3">
        {{ formDate.pressureTestUserPhone }}
        <a-button type="primary" style="margin-left: 30px"  @click="$refs.CreateMoney.init(formDate.pressureTestUserId)"> 调整资金 </a-button></a-descriptions-item
      >
    </a-descriptions>
    <a-descriptions :column="4" title="水工信息" class="full-width-descriptions">
      <a-descriptions-item label="水工姓名"> {{ formDate.waterName }} </a-descriptions-item>
      <a-descriptions-item label="水工电话" span="3">
        {{ formDate.waterPhone }}
        <a-button type="primary" style="margin-left: 30px" @click="$refs.CreateMoney.init(formDate.waterUserId)"> 调整资金 </a-button></a-descriptions-item
      >
      <!-- <a-descriptions-item label="  ">  <a-button type="primary" > 调整资金 </a-button> </a-descriptions-item> -->
    </a-descriptions>
    <a-form-model ref="form" :model="form" :rules="rules">
      <template v-if="showId === 1">
        <a-form-model-item label="审核状态" prop="acceptStatus">
          <a-radio-group button-style="solid" v-model="form.acceptStatus">
            <a-radio-button :value="2"> 审核打回 </a-radio-button>
            <a-radio-button :value="3"> 通过 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remarkVal" v-if="form.acceptStatus == 2">
          <a-input v-model="form.remarkVal" style="width: 500px" placeholder="请输入" type="textarea" allow-clear />
        </a-form-model-item>
      </template>
      <template v-else-if="showId === 10">
        <a-form-model-item label="VR文件" prop="vrFiles">
          <file-upload
            type="image"
            :defaultList="form.vrFiles"
            :file="form.stampImg"
            @input="getImg($event, 'vrFiles')"
            :count="12"
            :isUpload="false"
          ></file-upload>
        </a-form-model-item>
        <a-form-model-item label="VR地址" prop="vrUrl">
          <a-input v-model="form.vrUrl" placeholder="请输入" type="textarea" allow-clear />
        </a-form-model-item>
      </template>
      <template v-else-if="showId === 3">
        <div v-for="(item, index) in form.params" :key="index" class="model_t">
          <a-input v-model="item.dealersIntegral" placeholder="请输入经销商金豆"></a-input>
          <a-input
            v-model="item.inspectorPoints"
            placeholder="请输入验收员积分"
            oninput="value=value.replace(/[^\d]/g,'')"
          ></a-input>
          <a-input
            v-model="item.hydraulicIntegral"
            placeholder="请输入水工积分"
            oninput="value=value.replace(/[^\d]/g,'')"
          ></a-input>
          <a-input
            v-model="item.quantity"
            placeholder="请输入数量"
            oninput="value=value.replace(/[^\d]/g,'')"
          ></a-input>
        </div>
      </template>
      <template v-else-if="showId === 4">
        <a-form-model-item label="验收员" prop="pressureTestUserId">
          <a-select
            show-search
            v-model="form.pressureTestUserId"
            placeholder="请选择"
            option-filter-prop="children"
            :filter-option="filterOption"
            @change="handleChange"
            style="width: 500px"
          >
            <a-select-option
v-for="d in inspector"
:key="d.userId"
              >{{ d.userName }}({{ d.userPhone }})</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remarkVal">
          <a-input style="width: 500px" v-model="form.remarkVal" placeholder="请输入" type="textarea" allow-clear />
        </a-form-model-item>
      </template>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
      <CreateMoney ref="CreateMoney"></CreateMoney>
    </a-form-model>
  </a-drawer>
</template>
    <script>
import { getObj, orderExamine, orderVr, tenantUser, orderSend } from '@/api/pressure/dispatch'
import moment from 'moment'
import Examine from './examine'
import CreateMoney from '../../fund/modules/CreateForm.vue'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false,
    },
  },
  components: { Examine ,CreateMoney },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        acceptStatus: 2,
        remarkVal: undefined,
      },
      isShow: false,
      open: false,
      inspector: [],
      showId: 1,
      info: {},
      formDate: {},
      rules: {
        pressureTestUserId: [{ required: true, message: '请选择验收员', trigger: 'blur' }],
        vrFiles: [{ required: true, message: '请上传VR文件', trigger: 'blur' }],
        vrUrl: [{ required: true, message: '请输入VR地址', trigger: 'blur' }],
        remarkVal: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  methods: {
    // 时间选择
    onChange(e) {
      console.log(e, '121212888')
      this.form.reservationTime = moment(e).format('YYYY-MM-DD HH:mm')
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    // 查询验收和水工
    getUserList(type) {
      tenantUser({ type: type, pageNum: 1, pageSize: 999 }).then((res) => {
        this.inspector = res.data.records
        console.log(res.data, 'res.datares.datares.data')
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        acceptStatus: 2,
        remarkVal: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加预约订单'
    },
    // 验收员选择发生变化
    handleChange(e) {
      console.log(e, '的点点滴滴')
      this.inspector.forEach((v) => {
        if (v.userId === e) {
          this.form.pressureTestName = v.userName
          this.form.pressureTestUserPhone = v.userPhone
        }
      })
    },
    /** 修改按钮操作 */
    init(row, index) {
      console.log(row, 'rowrow')

      // this.reset()
      // this.form.id = row.id
      this.open = true
      this.showId = index
      if (index === 1) {
        this.formTitle = '审核'
        this.form = {
          acceptStatus: 2,
          remarkVal: '',
          id: row.id,
        }
        getObj(row.id).then((response) => {
          console.log(response.data, 'response.data')
          this.formDate = response.data
          // this.form.params = response.data.reportInfoResult.productModelResults
          // this.form = {
          //   params: response.data.reportInfoResult.productModelResults,
          //   id: row.id,
          // }
        })
        // this.info=row
      } else if (index === 3) {
        this.formTitle = '修改积分'
        getObj(row.id).then((response) => {
          console.log(response.data, 'response.data')
          this.form = response.data
          this.form.params = response.data.reportInfoResult.productModelResults
          this.form = {
            params: response.data.reportInfoResult.productModelResults,
            id: row.id,
          }
        })
        // this.form.params = [{ name: '' }],
      } else if (index === 4) {
        this.formTitle = '派单'
        this.form.id = row.id
        // getObj(row.id).then((response) => {
        //   console.log(response.data, 'response.data')
        //   const res = response.data
        //   this.form.params = response.data.reportInfoResult.productModelResults
        // })
        this.getUserList(0)
      } else {
        this.formTitle = '配置VR'
        this.form = {
          vrFiles: [],
          vrUrl: '',
          id: row.id,
        }
      }
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.showId === 4) {
            orderSend(this.form)
              .then((response) => {
                this.$message.success('操作成功', 3)
                this.open = false
                this.$emit('ok')
                this.$emit('changeStatus')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else if (this.showId === 1) {
            orderExamine(this.form)
              .then((response) => {
                this.$message.success('审核成功', 3)
                this.open = false
                this.$emit('ok')
                this.$emit('changeStatus')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            orderVr(this.form)
              .then((response) => {
                this.$message.success('操作成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
    <style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>